module.exports = __webpack_public_path__ + "img/suitcase.f6b44e05.png";